import { render, staticRenderFns } from "./Airports.vue?vue&type=template&id=29b12c66&scoped=true&"
import script from "./Airports.vue?vue&type=script&lang=js&"
export * from "./Airports.vue?vue&type=script&lang=js&"
import style0 from "./Airports.vue?vue&type=style&index=0&id=29b12c66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b12c66",
  null
  
)

export default component.exports